/**
 * @function v3sButton
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * Erstellt einen Button. Der Buttontype leitet sich vom Attribute "name" ab.
 * Momentan gibt es die Buttontypes die sich aus Bootstrap ergeben.
 */

angular.module('v3sWbtPlayerApp').directive('v3sButton', ["v3sContentMediaPath", "v3sIconService", "v3sHypertextService", function (v3sContentMediaPath, v3sIconService, v3sHypertextService) {
    return {
        restrict: 'E',
        require: '^^v3sDocument',
        scope: {
            id: '@',
            v3sType: '@',
            v3sName: '@',
            v3sWidth: '@',
            v3sHeight: '@'
        },
        transclude: true,
        link: function (scope, element, attrs, docCtrl, transclude) {

            if (!!scope.id) {
                docCtrl.addElement(element);
            }
            if (!element.hasClass('clickable')) {
                element.addClass('clickable');
            }

            scope.item = null;

            var iconClass = v3sIconService.getIconClass(attrs.v3sType || scope.v3sName);

            var width = parseInt(scope.v3sWidth);
            var height = parseInt(scope.v3sHeight);

            if (!height) {
                height = 30;
            }

            var minSize = width < height ? width : height;
            var activeImgUrl = "",
                overImgUrl = "",
                pressedImgUrl = "",
                incompleteImgUrl = "",
                completedImgUrl = "",
                failedImgUrl = "",
                defaultStateImgUrl = "";
            var completed = false;
            


            //Smart-Flow min-height
            element.css('min-height', height + "px");

            //Standard-Grafik
            if (!!attrs.v3sFile && !iconClass) {
                activeImgUrl = 'url(./' + v3sContentMediaPath + attrs.v3sFile + ')';
                defaultStateImgUrl = activeImgUrl;
                element.addClass('with-background-image');
            }

            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node) {
                    var tagName = node.tagName.toLowerCase();
                    var innerText = node.textContent;
                    var ngNode = angular.element(node);
                    if (tagName == "v3s-tooltip" && (!!innerText || !!ngNode.attr('v3s-file'))) {

                        var data = ngNode.find('v3s-data');

                        //Es ist ein TextButton
                        if (!activeImgUrl && !iconClass) {
                            element.append(data);
                            element.addClass('v3s-text-button');
                            if (!!ngNode.attr('v3s-file')) {
                                element.append(node);
                            }
                        } else if (minSize >= 100) {
                            data.addClass("tile");
                            element.append(data);
                            if (!!ngNode.attr('v3s-file')) {
                                element.append(node);
                            }
                        } else {
                            element.append(node);
                        }

                    } else if (tagName == "v3s-pressed" && !!ngNode.attr('v3s-file')) {
                        pressedImgUrl = 'url(./' + v3sContentMediaPath + ngNode.attr('v3s-file') + ')';
                    } else if (tagName == "v3s-over" && !!ngNode.attr('v3s-file')) {
                        overImgUrl = 'url(./' + v3sContentMediaPath + ngNode.attr('v3s-file') + ')';
                    } else if (tagName == "v3s-incomplete" && !!ngNode.attr('v3s-file')) {
                        incompleteImgUrl = 'url(./' + v3sContentMediaPath + ngNode.attr('v3s-file') + ')';
                    } else if (tagName == "v3s-completed" && !!ngNode.attr('v3s-file')) {
                        completedImgUrl = 'url(./' + v3sContentMediaPath + ngNode.attr('v3s-file') + ')';
                    } else if (tagName == "v3s-failed" && !!ngNode.attr('v3s-file')) {
                        failedImgUrl = 'url(./' + v3sContentMediaPath + ngNode.attr('v3s-file') + ')';
                    } else if (tagName == "v3s-reference") {

                        var updateCompletedState = function (state, exerciseState) {
                            completed = false;
                            if (state == "incomplete" && !!incompleteImgUrl) {
                                defaultStateImgUrl = incompleteImgUrl;
                            } else if (state == "completed" && !!completedImgUrl) {
                                completed = true;
                                defaultStateImgUrl = completedImgUrl;
                            } else if (!!activeImgUrl) {
                                defaultStateImgUrl = activeImgUrl;
                            }

                            if (state == "completed" && exerciseState == "failed" && failedImgUrl) {
                                defaultStateImgUrl = failedImgUrl;
                            }
                            element.css('background-image', defaultStateImgUrl);
                        };

                        var updateLockState = function (locked) {
                            if (locked) {
                                element.addClass("locked");
                            } else if (element.hasClass('locked')) {
                                element.removeClass("locked");
                            }
                        };

                        var linkConfig = {
                            itemId: ngNode.attr('v3s-itemid'),
                            popupId: ngNode.attr('v3s-refid'),
                            filePath: ngNode.attr('v3s-file'),
                            url: ngNode.attr('v3s-url'),
                            entry: ngNode.attr('v3s-entry')
                        };

                        v3sHypertextService.createLinkOnClick(
                            element,
                            linkConfig,
                            scope,
                            updateCompletedState,
                            updateLockState);

                        // Ggf. zu Referenz passendes Icon wählen
                        var data = element.find('v3s-data');
                        if (!iconClass && !attrs.v3sFile && data.length == 0) {
                            var type = v3sHypertextService.getLinkType(linkConfig);
                            iconClass = v3sIconService.getIconClass(type);
                        }
                    }
                });
            });

            //Grafik MouseOver, gedrückt
            if (defaultStateImgUrl) {
                var mouseOver = false;

                //MouseOver
                if (!!overImgUrl) {
                    element.on('mouseover', function () {
                        if (!completed) {
                            element.css('background-image', overImgUrl);
                            mouseOver = true;
                        }
                    });
                    element.on('mouseout', function () {
                        if (!completed) {
                            element.css('background-image', defaultStateImgUrl);
                            mouseOver = false;
                        }
                    });
                }

                //MouseDown
                if (!!pressedImgUrl) {
                    element.on('mousedown', function () {
                        if (!completed) {
                            element.css('background-image', pressedImgUrl);
                        }
                    });
                    element.on('mouseup', function () {
                        if (!completed) {
                            if (!!overImgUrl && mouseOver) {
                                element.css('background-image', overImgUrl);
                            } else {
                                element.css('background-image', defaultStateImgUrl);
                            }
                        }
                    });
                }
            }

            //Icon hinzufügen
            if (!!iconClass) {
                var icon = angular.element("<span/>");
                icon.addClass('v3s-icon v3s-icon-button ' + iconClass);
                icon.css('font-size', minSize * 0.6 + "px");
                icon.css('line-height', height + "px");
                element.append(icon);
            }
        }
    }
}]);
